module.exports = __webpack_public_path__ + "static/media/plus-circle.a9b77491.svg";